import { Base, useResize } from '@studiometa/js-toolkit';

// En dessous du breakpoint `m` (48rem), le sticky n'est pas appliqué côté CSS
// (`m:sticky`) : il n'y a donc rien à gérer.
const MOBILE_BREAKPOINTS = new Set(['2xs', 'xs', 's']);

/**
 * Block About.
 *
 * Sur grand écran, la section est `sticky top-0` : elle reste épinglée pendant
 * que le bloc Partenaires (opaque, `z-1`) remonte par-dessus — c'est l'effet de
 * révélation. Mais si le contenu « À propos » est plus haut que le viewport
 * (écran court), sa partie basse reste sous la ligne de flottaison et se fait
 * recouvrir avant d'avoir pu être lue.
 *
 * Ce composant désactive donc le `sticky` (via un override inline `position`)
 * dès que le contenu ne tient pas dans la hauteur du viewport : la section
 * défile alors normalement et peut être lue en entier avant que Partenaires ne
 * la recouvre. Le `sticky` est restauré dès que la place est de nouveau
 * suffisante (resize / changement d'orientation).
 * @augments {Base}
 */
export default class About extends Base {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'About',
  };

  /**
   *
   */
  mounted() {
    this.update();
  }

  /**
   * Auto-bound by the `resized` service.
   */
  resized() {
    this.update();
  }

  /**
   *
   */
  destroyed() {
    this.$el.style.position = '';
  }

  /**
   * Active le sticky uniquement quand la section tient dans le viewport ;
   * sinon, force un défilement normal pour garantir la lecture complète.
   */
  update() {
    const { breakpoint } = useResize().props();
    const isMobile = MOBILE_BREAKPOINTS.has(breakpoint);
    const fitsInViewport = this.$el.offsetHeight <= window.innerHeight;

    // Sticky pertinent seulement sur grand écran ET si le contenu tient.
    if (!isMobile && fitsInViewport) {
      // On retire l'override : la classe Tailwind `m:sticky` reprend la main.
      this.$el.style.position = '';
    } else {
      // On neutralise le sticky pour laisser la section défiler entièrement.
      this.$el.style.position = 'relative';
    }
  }
}
